import {Badge, Button, Card, CardBody, Col, Table} from "reactstrap";
import React, {Fragment, useEffect, useState} from "react";
import {toast} from "react-toastify";
import {createUkOrderApi, showUkOrderApi} from "../../../../services/order";

const STATUS = {
    pending: {label: 'Pending', color: 'secondary'},
    no_uk_items: {label: 'No UK items', color: 'light'},
    draft_created: {label: 'Draft created', color: 'warning'},
    created: {label: 'Created', color: 'success'},
    error: {label: 'Error', color: 'danger'},
};

/**
 * UK Shopify order of this India order (only the quantity allocated to the UK location).
 * Created automatically; the button creates / retries it manually.
 * orderId = orders.id
 */
export const UkOrder = (props) => {
    const {colSize, orderId, canCreate} = props;
    const [data, setData] = useState(null);
    const [creating, setCreating] = useState(false);

    useEffect(() => {
        showUkOrderApi(orderId)
            .then(({response}) => setData(response))
            .catch(() => setData(null));
    }, [orderId]);

    const createUkOrder = () => {
        setCreating(true);
        createUkOrderApi(orderId)
            .then(({response}) => {
                setData(response);
                if (response.success) {
                    toast.success(response.message, {position: toast.POSITION.TOP_RIGHT});
                } else {
                    toast.error(response.message || 'Could not create UK order', {position: toast.POSITION.TOP_RIGHT});
                }
            })
            .catch(() => toast.error('Could not create UK order', {position: toast.POSITION.TOP_RIGHT}))
            .finally(() => setCreating(false));
    };

    // Nothing to show for orders without UK quantity and no UK order record
    if (!data || (data.uk_quantities.length === 0 && !data.uk_order)) {
        return null;
    }

    const ukOrder = data.uk_order;
    const status = ukOrder ? (STATUS[ukOrder.status] || {label: ukOrder.status, color: 'secondary'}) : STATUS.pending;
    const isCreated = ukOrder && ukOrder.uk_order_number;
    const showButton = canCreate && !isCreated && data.is_paid && !data.is_canceled;

    return (
        <Fragment>
            <Col sm={colSize}>
                <Card className="ribbon-wrapper">
                    <CardBody>
                        <div className="ribbon ribbon-clip ribbon-info h6">UK Order</div>
                        <div className="mb-2">
                            <b className="text-secondary">Status:</b> <Badge color={status.color}>{status.label}</Badge>
                        </div>
                        {isCreated && (
                            <div className="mb-2"><b className="text-secondary">UK Order:</b> {ukOrder.uk_order_name}</div>
                        )}
                        {ukOrder && ukOrder.error_message && (
                            <div className="mb-2 text-danger" style={{wordBreak: 'break-word'}}>{ukOrder.error_message}</div>
                        )}
                        {!data.is_paid && !isCreated && (
                            <div className="mb-2 text-muted">Created once the order is paid.</div>
                        )}
                        {data.uk_quantities.length > 0 && (
                            <Table size="sm" className="mb-2">
                                <thead>
                                <tr>
                                    <th>UK SKU</th>
                                    <th className="text-right">Qty</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.uk_quantities.map((item, index) => (
                                    <tr key={index}>
                                        <td title={item.sku}>{item.uk_sku}</td>
                                        <td className="text-right">{item.quantity}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        )}
                        {showButton && (
                            <Button color="primary" size="sm" disabled={creating} onClick={createUkOrder}>
                                {creating ? 'Creating…' : (ukOrder && ukOrder.status === 'error' ? 'Retry UK Order' : 'Create UK Order')}
                            </Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};
